import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./semireal-gallery.css";
import React, { useEffect, useState } from "react";

const images = [
  "/cms-list/adopt1.jpg",
  "/cms-list/adopt2.jpg",
  "/cms-list/adopt3.jpg",
  "/cms-list/adopt4.jpg",
  "/cms-list/adopt5.jpg",
];

function AdoptableGallery() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      handleNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  const openLightbox = (image) => {
    setSelectedImage(image);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const getDisplayedImages = () => {
    const displayedImages = [];
    for (let i = 0; i < 3; i++) {
      displayedImages.push(images[(currentIndex + i) % images.length]);
    }
    return displayedImages;
  };

  return (
    <div className="gallery-container">
      <h1 className="header-semireal-gl">･ﾟAdoptable Gallery･ﾟ</h1>
      <div className="gallery-slider">
        <button className="arrow left-arrow" onClick={handlePrev}>
          &#8249;
        </button>
        <div className="slider-track">
          {getDisplayedImages().map((image, index) => (
            <div className="slide" key={index}>
              <img
                src={image}
                alt={`Artwork ${currentIndex + index + 1}`}
                onClick={() => openLightbox(image)}
              />
            </div>
          ))}
        </div>
        <button className="arrow right-arrow" onClick={handleNext}>
          &#8250;
        </button>
      </div>

      {selectedImage && (
        <div className="lightbox" onClick={closeLightbox}>
          <img src={selectedImage} alt="Full View" />
        </div>
      )}
    </div>
  );
}

export default AdoptableGallery;
